module.exports = __webpack_public_path__ + "assets/img/omplete.dbb20b2b.svg";